module.exports = __webpack_public_path__ + "static/media/kiki-loc.234c8f29.JPG";